/**
 * LpAccordion
 * 質問をクリックで開閉する（22 FAQ）。
 *
 * @usage
 * <div class="js-lp-accordion">
 *   <div class="p-lp-faq-item">
 *     <button class="js-lp-ac-btn" aria-expanded="false" aria-controls="faq1">…</button>
 *     <div class="js-lp-ac-content" id="faq1">
 *       <div><p>…</p></div>   ← 直下の子は overflow: hidden。paddingは孫に付ける
 *     </div>
 *   </div>
 *
 * **本体サイトの `_modules/Accordion.js` は使わない。**LPは `app.js` と独立していて
 * `_lp` 配下のモジュールしか読まない流儀（17の `LpToggleMore` も同じ理由で新規に起こした）。
 *
 * **高さは測らない。**本体の `Accordion.js` は `getBoundingClientRect()` で測って
 * CSS変数に書く作りだが、**22は13件が `display: none` で始まる**ので初期化時に測ると0になり、
 * 「残り13件を見る」で出したあと開いても高さ0のまま、という事故が構造的に起きる。
 * grid（0fr→1fr）なら測らないので起きない。
 *
 * 閉じるのは `<html>` に `has-lp-accordion` が付いてからなので、
 * **JSが動かなければ全部開いたまま出る**（LPの流儀＝完成状態で出す）。
 * FAQは中身が読めることが最優先なので、この向きで正しい。
 */

export default class LpAccordion {
  /**
   * @param {HTMLElement} element - `.js-lp-accordion`
   */
  constructor(element) {
    this.element = element;
    this.buttons = Array.from(element.querySelectorAll('.js-lp-ac-btn'));
    if (!this.buttons.length) {
      return;
    }

    document.documentElement.classList.add('has-lp-accordion');
    this.onClick = this.toggle.bind(this);
    this.buttons.forEach((button) => button.addEventListener('click', this.onClick));
  }

  /**
   * @param {MouseEvent} event
   */
  toggle(event) {
    const button = event.currentTarget;
    const item = button.parentElement;
    const isOpen = !item.classList.contains('is-open');
    item.classList.toggle('is-open', isOpen);
    button.setAttribute('aria-expanded', String(isOpen));
  }

  destroy() {
    this.buttons.forEach((button) => button.removeEventListener('click', this.onClick));
  }
}
